import React from "react";

const H2Icon = props => (
  <svg width={17} height={9} viewBox="0 0 17 9" {...props}>
    <defs>
      <linearGradient id="a" x1="-15.842%" x2="109.964%" y1="13.157%" y2="116.349%">
        <stop offset="0%" stopColor="#00B1FF" />
        <stop offset="72.016%" stopColor="#0060E7" />
        <stop offset="100%" stopColor="#0046DF" />
        <stop offset="100%" stopColor="#D3E1EF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(-540 -707)">
      <path fill="url(#a)" d="M0 85h1439v635H0z" />
      <rect width={730} height={1584} x={65} y={458} fill="currentColor" rx={5} />
      <g transform="translate(387 695)">
        <rect width={258} height={32} fill="#212121" rx={4} />
        <path
          fill="currentColor"
          d="M161.402 21H159.4v-3.736h-4.412V21H153v-8.867h1.988v3.483h4.412v-3.483h2.002V21zM170 21h-7.03v-1.489c3.823-2.685 4.944-3.59 4.944-4.68 0-.784-.743-1.156-1.513-1.156-1.064 0-1.876.399-2.506 1.024l-1.135-1.25c.91-.997 2.297-1.449 3.6-1.449 2.002 0 3.57 1.064 3.57 2.832 0 1.515-1.316 2.831-3.739 4.506H170V21z"
        />
      </g>
    </g>
  </svg>
);

export default H2Icon;
